import React, { PureComponent } from 'react';

import {
    View,
    StyleSheet
} from 'react-native';
import {
    JDTouchable,
    JDText
} from '@jdreact/jdreact-core-lib';

import LinearGradient from '@jdreact/jdreact-core-linear-gradient';

import { pt } from '../../common/utils';

export default class LoginBottom extends PureComponent {
    componentDidMount() {

    }

    render() {
        const { isLogin, login } = this.props;

        return (
            !isLogin && <JDTouchable onPress={ login } style={ st.bottom }>
                <LinearGradient colors={ ['rgba(255,255,255,0)', '#f7f7f7'] } style={ st.linear } />
                <View style={ st.bMain }>
                    <JDText style={ st.gray }>登录后可享受实际优惠价购票</JDText>
                    <View style={ st.login }>
                        <JDText style={ st.write }>登录</JDText>
                    </View>
                </View>
            </JDTouchable>

        );
    }
}

const st = StyleSheet.create({
    bottom: {
        height: pt(55),
        width: pt(375),
        position: 'absolute',
        bottom: 0,
        left: 0
    },
    bMain: {
        height: pt(50),
        width: pt(375),
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#fff',
        flexDirection: 'row',
        paddingRight: pt(10),
        paddingLeft: pt(10)
    },
    gray: {
        color: '#898989',
        fontSize: pt(12),
        justifyContent: 'flex-start'
    },
    login: {
        height: pt(24),
        width: pt(50),
        backgroundColor: '#E2231A',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: pt(24)
    },
    write: {
        color: '#fff',
        fontSize: pt(13)
    },
    linear: {
        width: pt(375),
        height: pt(5)
    }
});

module.exports = LoginBottom;
